import React, {useEffect, useContext, useCallback, useState} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import {useMenu} from '../../../hooks/useMenu';
import ConstantBatchTN from '../constant-batch/constant-batchTN';
import CommandsContext from '../../../context/commandsContext';

function ConstantBatch({onExit, initiallyDisableKeypress}) {
  const {onUpdateCommands} = useContext(CommandsContext);
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);

  const onRight = useCallback(() => {
    onExit();
    onComponent(<ConstantBatchTN />);
  }, []);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onRight, onLeft: onExit});
  }, [onRight, onExit]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="Enter Constant Batch Mode"
      left="No"
      right="Yes"
      caption="Do you want to enable Constant Batch mode? A password will be required later to exit
      Constant Batch mode."
    />
  );
}

export default ConstantBatch;
